  <div class="containerPhotos" >
    <img class="mat-elevation-z8" src="{{imageSrc}}" [ngStyle]="sizePicture">
  </div>

  
  